import { INode, INodeProps } from '@/types/node';
import { convertFromRaw, Editor, EditorState } from 'draft-js';
import React from 'react';
import { Theme } from '@mui/material/styles';
import {
  blockRenderMap,
  blockStyleFn,
  decorators,
} from '@/rich-text/utilities';
import { IContent } from './contract';
import { useNodeProps } from '@/node-editor/hooks';
import { getSpacerValue } from '@/lib/utils/format';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

interface IStyleProps {
  override: Record<string, any>;
  verticalSpacing: IContent['verticalSpacing'];
}

const useStyles = (
  theme: Theme,
  { override, verticalSpacing }: IStyleProps
) => ({
  root: {
    width: '100% !important',
    paddingTop: `${theme.spacing(
      getSpacerValue(verticalSpacing.top)
    )}px !important`,
    paddingBottom: `${theme.spacing(
      getSpacerValue(verticalSpacing.bottom)
    )}px !important`,
    '& .editor-alignment-left': { textAlign: 'left !important' },
    '& .editor-alignment-center': { textAlign: 'center !important' },
    '& .editor-alignment-right': { textAlign: 'right !important' },
    ...override.root,
  },
});

export const Render = ({
  node: {
    id,
    override,
    content: { richContent, verticalSpacing },
  },
}: IProps) => {
  const theme = useTheme();
  const classes = useStyles(theme, { override, verticalSpacing });

  const editorState =
    richContent.blocks.length > 0
      ? EditorState.createWithContent(convertFromRaw(richContent), decorators)
      : EditorState.createEmpty(decorators);

  return (
    <Box sx={classes.root} {...useNodeProps(id)}>
      <Editor
        onChange={() => null}
        blockRenderMap={blockRenderMap}
        blockStyleFn={blockStyleFn}
        editorState={editorState}
        readOnly
      />
    </Box>
  );
};
